const INITIAL_STATE = {
  stateStatus: 'Loading',
  loggedInPerson: {},
  currentPerson: {}
};

const LandingPageData = { INITIAL_STATE };
export default LandingPageData;